export const rowHover = "transition-colors duration-150 hover:bg-foreground/[0.05]";
